module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sn-wrap"
  }, [_c('nav', {
    staticClass: "sn-content",
    attrs: {
      "aria-label": "Section navigation"
    }
  }, [_c('ul', {
    staticClass: "sn-list"
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('li', {
      key: index,
      staticClass: "sn-item"
    }, [_c('router-link', {
      staticClass: "sn-link",
      attrs: {
        "exact-active-class": "sn-link--active",
        "to": item.to
      }
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])], 1)]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ee7fd8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubNavigation.vue
// module id = 1699
// module chunks = 2